module.exports = __webpack_public_path__ + "img/empty-development.676aa722.svg";